module.exports = __webpack_public_path__ + "fonts/BlenderPro-Heavy.92fe91f.woff";